import React from "react";

const Faq = () => {
  return (
    <div className="container mx-auto mt-20" data-aos="fade-up" data-aos-duration="2000">
      <div className="collapse my-10">
        <input type="checkbox" className="peer" />
        <div className="collapse-title bg-emerald-500 text-primary-content peer-checked:bg-emerald-500 peer-checked:text-secondary-content">
          How we get support ?
        </div>
        <div className="collapse-content bg-emerald-500 text-primary-content peer-checked:bg-emerald-700 peer-checked:text-secondary-content">
          <p>
            Go to Your profile and take a look arround.You will find a suport
            button.click there and wait for our support team.
          </p>
        </div>
      </div>
      <div className="collapse my-10">
        <input type="checkbox" className="peer" />
        <div className="collapse-title bg-emerald-500 text-primary-content peer-checked:bg-emerald-500 peer-checked:text-secondary-content">
          Why should you buy course from here ?
        </div>
        <div className="collapse-content bg-emerald-500 text-primary-content peer-checked:bg-emerald-700 peer-checked:text-secondary-content">
          <p>
            Well !!! In our platform we tried our best to give you the perfection.Our mentor are very experienced.You will get the best from here.also our support you will for liftime.once you are in our community , you will our asset.cz our target to every student will be a assest for each of nations.
          </p>
        </div>
      </div>
      <div className="collapse my-10">
        <input type="checkbox" className="peer" />
        <div className="collapse-title bg-emerald-500 text-primary-content peer-checked:bg-emerald-500 peer-checked:text-secondary-content">
          After finishing the course what the benefit you will get ?
        </div>
        <div className="collapse-content bg-emerald-500 text-primary-content peer-checked:bg-emerald-700 peer-checked:text-secondary-content">
          <p>
            Well !!! In our platform we tried our best to give you the perfection.Our mentor are very experienced.You will get the best from here.also our support you will for liftime.once you are in our community , you will our asset.cz our target to every student will be a assest for each of nations.
          </p>
        </div>
      </div>
      <div className="collapse">
        <input type="checkbox" className="peer" />
        <div className="collapse-title bg-emerald-500 text-primary-content peer-checked:bg-emerald-500 peer-checked:text-secondary-content">
          Why should you buy course from here ?
        </div>
        <div className="collapse-content bg-emerald-500 text-primary-content peer-checked:bg-emerald-700 peer-checked:text-secondary-content">
          <p>
            Well !!! In our platform we tried our best to give you the perfection.Our mentor are very experienced.You will get the best from here.also our support you will for liftime.once you are in our community , you will our asset.cz our target to every student will be a assest for each of nations.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Faq;
